var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvocado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4A38B;}\n\t.st1{fill:#B2D067;stroke:#9EC862;stroke-width:2.7953;stroke-miterlimit:10;}\n\t.st2{fill:#006731;stroke:#006731;stroke-width:2.0965;stroke-miterlimit:10;}\n\t.st3{fill:#9D6D5D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.5,59.36c-17.45-2.07-38.03,41.5-40.1,58.95c-2.08,17.45,10.38,33.27,27.83,35.35 c17.45,2.08,33.27-10.38,35.35-27.83C137.65,108.38,129.95,61.44,112.5,59.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M112.75,57.28c-19.32-2.3-40.26,42.49-42.43,60.78c-2.21,18.56,11.1,35.47,29.66,37.68 c18.56,2.21,35.47-11.1,37.68-29.66C139.64,109.38,132.56,59.64,112.75,57.28z M133.49,125.58c-1.94,16.27-16.75,27.93-33.01,26 c-16.27-1.94-27.93-16.75-25.99-33.02c1.97-16.54,22.08-58.98,37.77-57.11C127.79,63.29,135.47,108.93,133.49,125.58z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M107.33,99.88c-7.65-0.91-15.16,9.32-16.3,18.93c-1.14,9.62,4.5,14.98,12.16,15.89 c7.65,0.91,14.4-2.98,15.54-12.6C119.88,112.49,114.98,100.79,107.33,99.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M107.58,97.79c-7.52-0.89-17.08,7.8-18.63,20.77c-1.18,9.92,4.31,17.07,13.99,18.22 c9.68,1.15,16.69-4.51,17.87-14.43C122.36,109.38,115.1,98.69,107.58,97.79z M116.65,121.86c-0.91,7.62-5.85,11.64-13.21,10.76 c-7.37-0.87-11.23-5.94-10.32-13.56c0.99-8.33,7.63-17.85,13.97-17.1C113.42,102.72,117.64,113.53,116.65,121.86z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvocado);
export default __webpack_public_path__ + "static/media/Avocado.c9b96a12a4da94a4c3da42a92b725612.svg";
export { ForwardRef as ReactComponent };